import {
  Box,
  Button,
  Container,
  Grid,
  TextField,
  Typography,
} from "@mui/material";

const LockScreen = () => {
  const logoutTitle = {
    textAlign: "center",
    fontWeight: "bold",
    color: "#004186",
    marginBottom: "18px",
  };
  return (
    <Grid>
      <Typography sx={{ ...logoutTitle, color: "#4C4C4C" }} variant="h5">
        Your screen is locked
      </Typography>
      <Container style={{ textAlign: "center" }}>
        <TextField
          variant="outlined"
          type="password"
          fullWidth
          placeholder="Please enter password"
          sx={{ height: "48px" }}
        />
      </Container>
      <Box sx={{ textAlign: "center" }}>
        <Button variant="contained" sx={{ width: "91%", marginTop: "24px" }}>
          <Typography sx={{ fontWeight: "bold" }}>Unlock Now</Typography>
        </Button>
      </Box>
    </Grid>
  );
};

export default LockScreen;
